var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "jobmatchresultcontainer" },
    [
      _c(
        "b-tabs",
        { staticClass: "mt-4" },
        [
          _c(
            "b-tab",
            {
              attrs: {
                "title-link-class": _vm.deepLinkJobId !== 0 ? "notactive" : "",
              },
              on: {
                click: function ($event) {
                  _vm.disableSearchForMore(false), _vm.changeTab("jobmatch")
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center" },
                        [
                          _c("b-icon", {
                            staticClass: "mr-2",
                            attrs: {
                              icon: "arrow-left-right",
                              "font-scale": "0.8",
                            },
                          }),
                          _vm._v("Job Match"),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm.deepLinkJobId === 0 && _vm.tabType === "jobmatch"
                ? _c("ResultPage", {
                    attrs: {
                      content: _vm.content,
                      settings: _vm.settings,
                      jobApplicationAccess: _vm.jobApplicationAccess,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              on: {
                click: function ($event) {
                  _vm.disableSearchForMore(true), _vm.changeTab("savedadvert")
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _vm.loadingAdverts
                        ? _c("b-skeleton", {
                            attrs: { width: "130px", height: "25px" },
                          })
                        : [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _c("HeartEmptyFull", {
                                  attrs: { isFull: _vm.count > 0 },
                                }),
                                _c("div", { staticClass: "ml-2" }, [
                                  _vm._v(
                                    _vm._s(_vm.t.general_Favorites) +
                                      " (" +
                                      _vm._s(_vm.count) +
                                      ")"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm.deepLinkJobId === 0 && _vm.tabType === "savedadvert"
                ? _c("Favorites", { attrs: { content: _vm.content } })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.deepLinkJobId !== 0
        ? _c("DeepLinkResult", { attrs: { content: _vm.content } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }